var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRightScroll(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 25,
    viewBox: "0 0 16 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.684 14.0101L3.88549 24.2691C3.19858 24.922 2.08486 24.922 1.39828 24.2691C0.711641 23.6167 0.711641 22.5587 1.39828 21.9064L10.9533 12.8288L1.39856 3.75153C0.711919 3.09892 0.711919 2.04098 1.39856 1.38863C2.08519 0.736017 3.19885 0.736017 3.88577 1.38863L14.6843 11.6477C15.0276 11.974 15.1991 12.4013 15.1991 12.8287C15.1991 13.2564 15.0273 13.684 14.684 14.0101Z",
    fill: "#003A9B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightScroll);
export default __webpack_public_path__ + "static/media/right-scroll.844146c11aba207d17d42eaec91d3c13.svg";
export { ForwardRef as ReactComponent };